import React from 'react'
import cx from 'classnames'
import styles from './index.css'

const Card = ({ className, children }) => (
  <div className={cx(styles.card, className)}>{children}</div>
)

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/index.js